export const getContainerFactoryStyles = () =>
  ({
    CategorizedDropdownListContainer: {
    },
  });
